export const tableData = (data, fecha_fin) => {
  const columns = [
    { field: "id", headerName: "ID", hide: true },
    {
      field: "numero_serie",
      headerName: "# Serie",
      minWidth: 50,
    },
    {
      field: "lugar",
      headerName: "Lugar",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "aprobadas",
      headerName: "Aprobadas",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "nuevas",
      headerName: "Nuevas",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "descartadas",
      headerName: "Descartadas",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "enviadas",
      headerName: "Enviadas",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "infracciones_count",
      headerName: "Nuestras",
      minWidth: 150,
    },
    {
      field: "fecha_colocacion",
      headerName: "Fecha Colocación",
      minWidth: 200,
    },
  ];

  const rows = data.map((d, index) => {
    return {
      id: d.id,
      numero_serie: d.numero_serie,
      equipo: d.equipo,
      modelo: d.modelo,
      lugar: d.lugar,
      latitud: d.latitud,
      longitud: d.longitud,
      infracciones_count: d.infracciones_count,
      aprobadas: d.numeros?.APROBADO ?? 0,
      nuevas: d.numeros?.NUEVO ?? 0,
      descartadas: d.numeros?.DESCARTADO ?? 0,
      enviadas: d.numeros?.ENVIADO ?? 0,
      fecha_colocacion: d.fecha_colocacion,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();
    return (
      String(d.numero_serie)?.toString().toLowerCase().includes(value) ||
      String(d.equipo)?.toString().toLowerCase().includes(value) ||
      String(d.modelo)?.toString().toLowerCase().includes(value) ||
      String(d.lugar)?.toString().toLowerCase().includes(value) ||
      String(d.latitud)?.toString().toLowerCase().includes(value) ||
      String(d.longitud)?.toString().toLowerCase().includes(value) ||
      String(d.infracciones_count)?.toString().toLowerCase().includes(value) ||
      String(d.fecha_colocacion)?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};
